import axios from 'axios'
import { useEffect, useState } from 'react'

let evidentlyFeatures: Record<string, boolean> | undefined
let evidentlyFeaturesPromise

const init = async () => {
  try {
    const { data } = await axios.get('/composer/api/v2/features')
    evidentlyFeatures = data
    return data
  } catch (e) {
    console.error('could not get evidently feature flags')
    return {}
  }
}

const getEvidentlyFeatures = async (): Promise<
  Record<string, boolean> | undefined
> => {
  if (evidentlyFeatures) return evidentlyFeatures
  if (evidentlyFeaturesPromise) return evidentlyFeaturesPromise

  evidentlyFeaturesPromise = init()
  return evidentlyFeaturesPromise
}

const useEvidentlyFeatures = () => {
  const [flags, setFlags] = useState<Record<string, boolean> | undefined>({})

  useEffect(() => {
    const loadFlags = async () => {
      const resolved = await getEvidentlyFeatures()
      setFlags(resolved)
    }
    loadFlags()
  }, [])

  return flags
}

export { getEvidentlyFeatures, useEvidentlyFeatures }
// export { getEvidentlyFeatures }
